import { jsx as c, jsxs as R } from "react/jsx-runtime";
import "./main.scss";
import { IconNames as e } from "@blueprintjs/icons";
import r from "classnames";
import { Icon as g } from "@blueprintjs/core";
import { Tooltip as l } from "@strata/react-tooltip";
const O = {
  COUNT: "count",
  ISSUES: "issues",
  UNREAD: "unread"
}, A = ({ count: n = 0, intent: s = O.COUNT }) => n > 0 ? /* @__PURE__ */ c("div", { className: `sds_badge sds_badge--${s}`, children: /* @__PURE__ */ c("span", { className: "sds_badge__count", children: n > 99 ? "99+" : n }) }) : null;
A.Intent = O;
const E = {
  DEFAULT: "default",
  SECONDARY: "secondary",
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",
  INFO: "info"
}, U = {
  [E.DEFAULT]: l.Intent.DEFAULT,
  [E.SECONDARY]: l.Intent.DEFAULT,
  [E.ERROR]: l.Intent.ERROR,
  [E.WARNING]: l.Intent.WARNING,
  [E.SUCCESS]: l.Intent.SUCCESS,
  [E.INFO]: l.Intent.INFO
}, o = ({
  icon: n,
  intent: s = void 0,
  tooltipContent: a = void 0,
  size: I = 16,
  className: D,
  popoverClassName: d,
  onClick: _,
  title: F
}) => /* @__PURE__ */ c(
  l,
  {
    content: a,
    intent: U[s ?? E.DEFAULT],
    className: r("sds_icon", { "sds_icon--clickable": _ }, D),
    popoverClassName: d,
    children: /* @__PURE__ */ c(
      g,
      {
        icon: n,
        size: I,
        onClick: _,
        className: r({ [`sds_icon--${s}`]: s }),
        title: F
      }
    )
  }
);
o.Intent = E;
const t = {
  ACCEPTED: "ACCEPTED",
  DENIED: "DENIED",
  DENIED_DOC: "DENIED_DOC",
  PAID: "PAID",
  PAYDIS: "PAYDIS",
  PAYDIS_ACK: "PAYDIS_ACK",
  PENDING: "PENDING",
  PEND_ADJ: "PEND_ADJ",
  PEND_PAY: "PEND_PAY",
  REJECTED: "REJECTED",
  WARNING: "WARNING"
}, W = {
  [t.ACCEPTED]: e.TICK,
  [t.DENIED]: e.HIGH_PRIORITY,
  [t.DENIED_DOC]: e.HIGH_PRIORITY,
  [t.PAID]: e.DOLLAR,
  [t.PAYDIS]: e.NOT_EQUAL_TO,
  [t.PAYDIS_ACK]: e.NOT_EQUAL_TO,
  [t.PENDING]: e.CIRCLE,
  [t.PEND_ADJ]: e.TAKE_ACTION,
  [t.PEND_PAY]: e.DOLLAR,
  [t.REJECTED]: e.CROSS,
  [t.WARNING]: e.WARNING_SIGN
}, u = {
  [t.ACCEPTED]: "Accepted",
  [t.DENIED]: "Denied",
  [t.DENIED_DOC]: "Denial Documented",
  [t.PAID]: "Paid",
  [t.PAYDIS]: "Payment Discrepancy",
  [t.PAYDIS_ACK]: "Payment Discrepancy Acknowledged",
  [t.PENDING]: "Pending",
  [t.PEND_ADJ]: "Pending Adjudication",
  [t.PEND_PAY]: "Pending Payment",
  [t.REJECTED]: "Rejected",
  [t.WARNING]: "Warning"
}, f = (n) => {
  switch (n) {
    case t.ACCEPTED:
    case t.DENIED_DOC:
    case t.PAID:
    case t.PAYDIS_ACK:
      return o.Intent.SUCCESS;
    case t.DENIED:
    case t.PAYDIS:
    case t.REJECTED:
      return o.Intent.ERROR;
    case t.WARNING:
      return o.Intent.WARNING;
    default:
      return;
  }
}, G = ({ status: n = t.PENDING }) => {
  const s = W[n] ?? e.CIRCLE, a = u[n], I = f(n), D = n === t.PENDING;
  return /* @__PURE__ */ c(
    "div",
    {
      className: r("sds_claim-status-icon", {
        [`sds_claim-status-icon--${I == null ? void 0 : I.toLowerCase()}`]: I,
        "sds_claim-status-icon--pending": D
      }),
      children: /* @__PURE__ */ c(
        o,
        {
          icon: s,
          size: D ? 20 : 12,
          intent: I,
          title: "Claim Status",
          tooltipContent: a,
          className: r("sds_claim-status-icon__icon", {
            [`sds_claim-status-icon__icon--${I == null ? void 0 : I.toLowerCase()}`]: I,
            "sds_claim-status-icon__icon--pending": D
          })
        }
      )
    }
  );
};
G.Statuses = t;
G.StatusTextMap = u;
const V = ({ size: n = 90, className: s = void 0 }) => /* @__PURE__ */ c(
  o,
  {
    className: r("sds_f-icon", s),
    icon: e.BLANK,
    size: n,
    title: "Free Market Health Logo"
  }
), i = {
  PEND_FILL: "PEND_FILL",
  IN_PROG: "IN_PROG",
  CLM_RCVD: "CLM_RCVD",
  CLM_WRNG: "CLM_WRNG"
}, M = {
  [i.PEND_FILL]: e.HIGH_PRIORITY,
  [i.IN_PROG]: e.DOCUMENT,
  [i.CLM_RCVD]: e.SAVED,
  [i.CLM_WRNG]: e.RANDOM
}, S = "Pending First Fill", m = "First Fill in Progress", C = {
  [i.PEND_FILL]: (n) => n ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ c("div", { className: "padding__bottom--medium", children: S }),
    /* @__PURE__ */ c("div", { children: "You can manually update to First Fill in Progress and/or wait for an automatic update from a received claim." })
  ] }) : S,
  [i.IN_PROG]: (n) => n ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ c("div", { className: "padding__bottom--medium", children: m }),
    /* @__PURE__ */ c("div", { children: "You can revert back to Pending First Fill and/or wait for an automatic update from a received claim." })
  ] }) : m,
  [i.CLM_RCVD]: () => "Claim Received",
  [i.CLM_WRNG]: () => "Claim From Wrong Pharmacy"
}, v = {
  [i.PEND_FILL]: o.Intent.WARNING,
  [i.IN_PROG]: o.Intent.DEFAULT,
  [i.CLM_RCVD]: o.Intent.SUCCESS,
  [i.CLM_WRNG]: o.Intent.ERROR
}, T = ({
  status: n = void 0,
  showActionDetail: s = !1
}) => {
  var d;
  if (n == null)
    return null;
  const a = M[n], I = v[n], D = (d = C[n]) == null ? void 0 : d.call(C, s);
  return /* @__PURE__ */ c(
    o,
    {
      icon: a,
      intent: I,
      title: "First Fill Status",
      tooltipContent: D,
      className: "sds_first-fill-status-icon"
    }
  );
};
T.Statuses = i;
T.StatusTextMap = C;
const j = ({
  tooltipText: n,
  size: s = 12,
  className: a,
  popoverClassName: I
}) => /* @__PURE__ */ c(
  o,
  {
    icon: e.INFO_SIGN,
    size: s,
    intent: o.Intent.INFO,
    title: "Info",
    tooltipContent: n,
    className: a,
    popoverClassName: I
  }
), B = ({ issues: n = [] }) => n.length === 0 ? null : /* @__PURE__ */ c(
  o,
  {
    icon: n.length === 1 ? e.WARNING_SIGN : /* @__PURE__ */ c(A, { count: n.length, intent: A.Intent.ISSUES }),
    intent: o.Intent.WARNING,
    tooltipContent: /* @__PURE__ */ c("div", { className: "flex__gap--xx-small", style: { flexDirection: "column" }, children: n.map((s) => /* @__PURE__ */ R("div", { className: "flex__gap--x-small", children: [
      /* @__PURE__ */ c(o, { icon: e.WARNING_SIGN }),
      /* @__PURE__ */ c("span", { children: s })
    ] }, s)) })
  }
), N = {
  CAUTION: "caution",
  GOOD: "good",
  WARNING: "warning",
  NONE: "none"
}, Y = {
  [N.CAUTION]: e.ERROR,
  [N.GOOD]: e.TICK_CIRCLE,
  [N.WARNING]: e.WARNING_SIGN,
  [N.NONE]: e.FULL_CIRCLE
}, h = {
  [N.CAUTION]: o.Intent.ERROR,
  [N.GOOD]: o.Intent.SUCCESS,
  [N.WARNING]: o.Intent.WARNING,
  [N.NONE]: void 0
}, x = ({
  status: n = N.NONE,
  tooltipText: s = void 0,
  size: a = 12,
  title: I,
  showEmptyCircle: D = !1,
  className: d,
  popoverClassName: _
}) => n !== N.NONE || D ? /* @__PURE__ */ c(
  o,
  {
    icon: Y[n],
    size: a,
    intent: h[n],
    tooltipContent: s,
    title: I,
    className: r("sds_status-icon", d),
    popoverClassName: _
  }
) : null;
x.Statuses = N;
const P = {
  GOOD: "good",
  BAD: "bad"
}, L = {
  UP: "up",
  DOWN: "down"
}, $ = {
  [P.GOOD]: o.Intent.SUCCESS,
  [P.BAD]: o.Intent.ERROR
}, p = ({ trendDirection: n, trendState: s, size: a = 12 }) => /* @__PURE__ */ c(
  o,
  {
    icon: n === L.UP ? e.TRENDING_UP : e.TRENDING_DOWN,
    intent: $[s],
    size: a
  }
);
p.States = P;
p.Directions = L;
export {
  A as Badge,
  G as ClaimStatusIcon,
  V as FIcon,
  T as FirstFillStatusIcon,
  o as Icon,
  j as InformationIcon,
  B as IssuesIcon,
  x as StatusIcon,
  p as TrendingIcon
};
//# sourceMappingURL=index.js.map
